<script>
import { Doughnut, mixins } from "vue-chartjs";

const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ["chartData", "options", "legendId"],
  mounted() {
    // http://www.chartjs.org/docs/latest/#creating-a-chart
    // this.chartData is created in the mixin
    // to pass in options, create a local options object
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData() {
      const legendContainer = document.getElementById(this.legendId);
      legendContainer.innerHTML = "";
      legendContainer.innerHTML = this.generateLegend();
    },
  },
};
</script>
